import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IDisciplineViewerList } from "Data/interfaces/FederatedViewer/IDisciplineViewerList";
import { Icon, IconName } from "Components/UI";
import SearchInputBase from "Components/UI/SearchInputBase";
import { IBreadcrumbPath } from "..";
import { Header } from "../styles";

interface IMoveFilesModalHeader {
  value: string;
  disciplineFolder: IDisciplineViewerList | null;
  isLoading: boolean;
  breadCrumbs: IBreadcrumbPath[];
  onSearch: (value: string) => void;
  onListDisciplines: () => void;
  onOpenFolder: (
    folderId: string,
    ConstructionSiteDisciplinesId?: number,
    folderName?: string,
    isObsoleteFolder?: boolean,
  ) => void;
  onIconLeft: (name: string) => IconName;
}

const MoveFilesModalHeader: FC<IMoveFilesModalHeader> = ({
  value,
  disciplineFolder,
  isLoading,
  breadCrumbs,
  onSearch,
  onListDisciplines,
  onOpenFolder,
  onIconLeft,
}) => {
  const { t } = useTranslation('listagemArquivos');

  return (
    <Header hasbreadcrumb={breadCrumbs.length > 0}>
      <div>
        <SearchInputBase
          value={value}
          placeholder={JSON.stringify(disciplineFolder) === '{}' ? t('moveFiles.searchDiscipline') : t('moveFiles.searchFolder')}
          onChange={onSearch}
        />
      </div>
      <div className="mainHeader">
        <Icon
          icon="menuHome"
          customSize={12}
          className="iconMenuHome"
          onClick={() => onListDisciplines()}
        />
        {(!isLoading && disciplineFolder) && (
          <div className="rowHeader">
            <Icon
              icon="retroceder"
              customSize={6}
              className="iconBreadCrumb"
            />
            <span
              className="rowHeaderDiscipline"
              onClick={() => onOpenFolder(
                disciplineFolder.DisciplineApiFolderId,
                disciplineFolder?.ConstructionSiteDisciplinesId,
              )}
            >
              <Icon
                icon={onIconLeft(disciplineFolder.CustomName || disciplineFolder.Discipline.Name)}
                customSize={10}
                className="iconLeft"
              />
              {disciplineFolder.CustomName || disciplineFolder.Discipline.Name}
            </span>
          </div>
        )}
        {!isLoading && (
          breadCrumbs.map((breadCrumb) => (
            <div className="rowHeader">
              <Icon
                icon="retroceder"
                customSize={6}
                className="iconBreadCrumb"
              />
              <span
                className="rowHeaderDiscipline"
                onClick={() => onOpenFolder(
                  breadCrumb.folderId,
                  breadCrumb?.ConstructionSiteDisciplinesId,
                  breadCrumb.name,
                  breadCrumb.isObsoleteFolder,
                )}
              >
                {breadCrumb.name}
              </span>
            </div>
          ))
        )}
      </div>
    </Header>
  )
}

export default MoveFilesModalHeader;
